'use client'

import {
  CLUB_EMAIL_CATEGORIES,
  EmailChannel
} from '../NotificationSettings/EmailChannel'
import S from '../NotificationSettings/NotificationSettings.module.scss'

export interface ClubNotificationSettingsProps {
  email?: string
}

/**
 * A club's notification settings (BAT-987, Confluence 76906819 §4): email
 * only — no notification centre and no Web Push for clubs in the MVP.
 */
export function ClubNotificationSettings({
  email
}: ClubNotificationSettingsProps) {
  return (
    <div className={S.root}>
      <EmailChannel email={email} categories={CLUB_EMAIL_CATEGORIES} />
    </div>
  )
}
